module.exports = __webpack_public_path__ + "img/logo-h.6c9261ac.png";